<template>
  <div>
    <video id="myVideo" class="video-js">
      <source
        src="@/assets/yanjiuyuan.m4v"
        type="video/mp4"
      />
    </video>
  </div>
</template>

<script>
/* eslint-disable */
    export default {
    data() {
        return {
			myPlayer: null,
		};
    },
    methods: {
        initVideo() {
			//初始化视频方法
			if (this.myPlayer === null) {
				this.myPlayer = this.$video(myVideo, {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,

					//自动播放属性,muted:静音播放,并且从视频加载完成后就开始播放
					autoplay: false,

					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "none",

					//设置视频播放器的显示宽度（以像素为单位,也可以使用%）
					width: "960px",

					//设置视频播放器的显示高度（以像素为单位,也可以使用%）
					height: "540px",

					//设置视频的封面
					poster:require("../assets/fengmian.png"),
				});
			}
        },
		stopVideo() {
			if (this.myPlayer !== null) {
				this.myPlayer.pause();
				this.myPlayer.src({ type: 'video/mp4', src: require("../assets/yanjiuyuan.m4v") });
			}
		}
    }
    };
</script>

<style scoped>
</style>